import React, { FC, useMemo } from 'react';

import { FileFilled } from 'ui/components/Icon';
import { converMimeToExtension } from 'ui/components/Upload/helpers';

import { EXTENSION_PATTERN } from './const';

import { FileIconProps, Size } from './types';

import { Extension, Wrapper } from './styled';

const FileIcon: FC<FileIconProps> = ({ size, type, attention, onClick }) => {
  const extension = useMemo(
    () => converMimeToExtension(type?.replace(EXTENSION_PATTERN, '') ?? '').replace('.', ''),
    [type],
  );

  return (
    <Wrapper size={size} attention={attention} onClick={onClick}>
      <Extension size={size}>{extension}</Extension>
      <FileFilled />
    </Wrapper>
  );
};

FileIcon.defaultProps = {
  size: Size.Middle,
};

export default FileIcon;
